<template>
  <div class="invite-view">
    <div class="invite-module">
      <invite-intro />
    </div>

    <div class="login-module">
      <invite-login />
    </div>
  </div>
</template>

<script>
  import InviteIntro from './components/invite-intro.vue'
  import InviteLogin from './components/invite-login.vue'

  export default {
    name: 'invite-view',

    components: { InviteIntro, InviteLogin }
  }
</script>

<style lang="scss" scoped>
  .invite-view {
    background: #fff;
    height: 100vh;
    padding-bottom: 280px;
    position: relative;

    .invite-module {
      width: 100%;
      height: 100%;
      overflow-y: auto;
    }

    .login-module {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 280px;
      background: #ffffff;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.1);
    }
  }
</style>
